import { usePropertyTrackTabs } from "../../hooks/property-tracker-tab";
import { Track } from "../../types";
import RentalActiveListingMobileTab from "./rental-listing/mobile";
import ResaleActiveListingMobileTab from "./resale-listing/mobile";
import HospitalityActiveListingTab from "./hospitality-listing";
import FullPageModal from "@/modules/common/components/ui-kit/full-page-modal/full-page-modal";

export default function ActiveListingMobileTab({
  open,
  onClose,
  track,
}: Readonly<{
  open: boolean;
  onClose: () => void;
  track: Track;
}>) {
  const {
    isRentalListingVisible,
    isResaleListingVisible,
    isHospitalityListingVisible,
  } = usePropertyTrackTabs({ track });

  if (isRentalListingVisible) {
    return (
      <RentalActiveListingMobileTab
        open={open}
        onClose={onClose}
        track={track}
      />
    );
  }

  if (isResaleListingVisible) {
    return (
      <ResaleActiveListingMobileTab
        open={open}
        onClose={onClose}
        track={track}
      />
    );
  }

  if (isHospitalityListingVisible) {
    return (
      <FullPageModal
        isOpen={open}
        title="Hospitality Listing"
        onClose={onClose}
      >
        <HospitalityActiveListingTab track={track} />
      </FullPageModal>
    );
  }
}
